 <mat-card class="slidecontent">
<!--  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      Main Workspace <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>  -->
 
  <!-- <button mat-flat-button class="cancel" (click)="closeTasksList()">
    Close
  </button>
   -->
<div class="taskcontainer">
  <div class="myDrive" [ngClass]="{ open: showmyDrive }">
   <div class="createdfolder">
    <div class="drive mainLink taskFilter" (click)="MyTaskFunction()">
       <div class="folderName active">
        <div class="mfname">
          <div class="nm" >
            <mat-icon class="type">task_alt</mat-icon> Task
          </div>
        </div>
       </div>     
     </div> 

      <div class="drive mainLink taskDashboard">
       <div class="mWorkspace">
         <h2>Task list</h2>
         <button mat-icon-button color="primary" (click)="ShowTemplateFromFolder(AddTaskListTemplate)">
          <mat-icon>add</mat-icon>
         </button>
       </div>

        
       <ng-container *ngFor="let list of taskLists">
        

        <!-- <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
         [ngClass]="{ 'active': taskListID === list.taskListID }">  

       
         <div class="name_email"  (click)="OpenTaskList(list)">
          <p  matTooltipClass="tooltip" matTooltip="{{list.taskListName}}"> 
          {{list.taskListName}}      
         </p>  
            
       </div>
           

      </div>  -->


      
        <div class="folderName" [ngClass]="{ 'active': taskListID === list.taskListID }">
            <div class="mfname">

              <div class="nm" (click)="OpenTaskList(list)">
                <!-- <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                  <span (click)="MailToAssignee(list)" *ngIf="list.isMailSent==false && list.showSendMailMenu==true">Send</span>
                  {{list.taskListName}}
                </p> -->

                <p matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                  {{list.taskListName}}           
                  <!-- *ngIf="list.isMailSent==false && list.showSendMailMenu==true" -->
                  <span *ngIf="list.isMailSent==false && list.showSendMailMenu==true"
                    (click)="MailToAssignee(list)" class="sendButton">Send</span>    
                </p>
               

                <!-- <mat-icon class="arrow_right" aria-hidden="true">

                  <div>
                    <ng-container *ngIf="!((currentTaskList == i) && taskListSelected)">
                      expand_more 
                    </ng-container>
                  </div>

                  <div >
                    <ng-container *ngIf="((currentTaskList == i) && taskListSelected)">
                      chevron_right
                    </ng-container>
                  </div>
                </mat-icon> -->

              </div>

              <div class="opt">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vertical</mat-icon>
                </button>
                <mat-menu #menu="matMenu">      
                  
                  <!-- <button mat-menu-item (click)="openTaskListUrl(list)">
                    <mat-icon>person_add</mat-icon>
                    Assign list
                  </button> -->
    
                  <button mat-menu-item (click)="openTaskListUrl(list)">
                    <mat-icon>content_copy</mat-icon>
                    Copy URL
                  </button>
    
                  <button mat-menu-item (click)="openTaskListUrl(list,true)">
                    <mat-icon>link</mat-icon>
                    Open External URL
                  </button>
    
                  <button *ngIf="list.showSendMailMenu==true" mat-menu-item (click)="MailToAssignee(list)">
                    <mat-icon>email</mat-icon>
                     Mail ({{ list.lastSent| date: "MM/dd/yyyy" }})
                  </button>

                  <button mat-menu-item (click)="updateTaskLists(updateFolderDialog,'task',list)">
                    <mat-icon>edit</mat-icon>
                    Rename
                  </button>                    
                 
    
                  <button mat-menu-item (click)="ShowTemplate(Addtemplate,list)">
                    <mat-icon>library_add</mat-icon> 
                    Add Template
                  </button>
    
                  <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog,list)">
                    <mat-icon>save</mat-icon>
                     Save as Template
                  </button>
    
                  <button mat-menu-item (click)="ImportTaskTemplateFromTaskList(importTasktemplate,list)">
                    <mat-icon>swap_horiz</mat-icon>
                    Import Task
                  </button>
    
                  <button mat-menu-item (click)="deleteTasklist(list)">
                    <mat-icon>delete</mat-icon>                  
                     Delete
                  </button>
    
                  <button mat-menu-item (click)="archivedTaskList(list)">
                    <mat-icon>archive</mat-icon>
                    Archive
                  </button>
    
                </mat-menu>
              </div>

            </div>

        </div>
            
         

                
      </ng-container>

    
       <!-- <ng-container *ngFor="let tasklist of taskListFolder; let i = index">
         <div class="folderName" [ngClass]="{ 'active': ((currentTaskList == i) && taskListSelected)}" >

           <div class="mfname">
 
             <div class="nm">
             
               <mat-icon class="arrow_right" aria-hidden="true">
                
                 <div (click)="getTaskLists(tasklist,i)">
                   <ng-container *ngIf="!((currentTaskList == i) && taskListSelected)">
                     chevron_right 
                   </ng-container>
                 </div>
                
                 <div (click)="getTaskLists1(tasklist,i)">
                 <ng-container *ngIf="((currentTaskList == i) && taskListSelected)">
                   expand_more
                 </ng-container>
               </div>
                </mat-icon>            
            
             <mat-icon class="type">folder</mat-icon>
             {{tasklist.taskListFolderName}}            
           </div>
          
          
           <div class="opt">
             <button mat-icon-button [matMenuTriggerFor]="menu">
               <mat-icon>more_vertical</mat-icon>
             </button>
             <mat-menu #menu="matMenu">
 
               <button mat-menu-item (click)="addTaskListTemp(AddTaskListTemplate,tasklist,i)">
                 <mat-icon>library_add</mat-icon> Add Task List
               </button>
             
 
               <button mat-menu-item (click)="updateFolder(updateFolderDialog,'folder',tasklist)">
                 <mat-icon>edit</mat-icon> Rename
               </button>
             
               <button mat-menu-item (click)="deleteTasklistFolder(tasklist)">
                 <mat-icon>delete</mat-icon>
                  Remove
               </button>
 
             </mat-menu>
           </div>
           </div>
           
           <ng-container *ngIf="taskLists.length>0 && i === expandedIndex && taskListSelected">
             <ng-container *ngFor="let list of taskLists">
   
            
               <div class="subTaskList" style="margin-left:0px;margin-right:0px; "
                [ngClass]="{ 'active': taskListID === list.taskListID }">  

               <mat-icon class="type">fiber_manual_record</mat-icon>
              <div class="name_email"  (click)="OpenTaskList(list)">
               <p  matTooltipClass="tooltip" matTooltip="{{list.taskListName}}" > 
                 {{list.taskListName}}      
                </p>  
                   
              </div>
                 <div class="opt">
                   <button mat-icon-button [matMenuTriggerFor]="menu">
                     <mat-icon>more_vertical</mat-icon>
                   </button>
                   <mat-menu #menu="matMenu">      
                     
                     <button mat-menu-item (click)="openTaskListUrl(list)">
                       <mat-icon>person_add</mat-icon>
                       Assign list
                     </button>
 
                     <button mat-menu-item (click)="openTaskListUrl(list)">
                       <mat-icon>link</mat-icon>
                       Copy Url
                     </button>
                     <button mat-menu-item (click)="openTaskListUrl(list,true)">
                       <mat-icon>link</mat-icon>
                       Open
                     </button>
                     <button mat-menu-item (click)="updateTaskLists(updateFolderDialog,'task',list,tasklist,i)">
                       <mat-icon>edit</mat-icon>
                       Rename
                     </button>
                            
                     <button mat-menu-item (click)="ShowTemplate(Addtemplate,list)">
                       <mat-icon>library_add</mat-icon> 
                       Add Template
                     </button>
       
                     <button mat-menu-item (click)="SaveAsTemplate(saveAsTemplateDialog,list)">
                       <mat-icon>save</mat-icon>
                        Save as Template
                     </button>
 
                     <button mat-menu-item (click)="deleteTasklist(list,tasklist,i)">
                       <mat-icon>delete</mat-icon>                  
                        Remove
                     </button>
       
                   </mat-menu>
                 </div> 
   
             </div>  
   
                       
             </ng-container>
           </ng-container>
 
 
         </div>
 
       </ng-container> -->
       
     </div> 

     <div class="drive mainLink">
      <div class="mWorkspace" style="margin-bottom: 10px;">
        <h2><mat-icon class="type">archive</mat-icon> Archived </h2>
      </div>


      <ng-container *ngFor="let tasklist of taskListArchived; let i = index">
        <div class="folderName"
          [ngClass]="{ 'active': ((currentTaskListArchived == i) && taskListSelectedArchived)}">

          <div class="mfname">

            <div class="nm">

              <!-- <mat-icon *ngIf="tasklist.id==1" class="arrow_right" aria-hidden="true">

                <div (click)="getTaskListsArchived(tasklist,i)">
                  <ng-container *ngIf="!((currentTaskListArchived == i) && taskListSelectedArchived)">
                    chevron_right
                  </ng-container>
                </div>

                <div (click)="getTaskLists1Archived(tasklist,i)">
                  <ng-container *ngIf="((currentTaskListArchived == i) && taskListSelectedArchived)">
                    expand_more
                  </ng-container>
                </div>
              </mat-icon> -->

              <span class="folderIconName" (click)="getTaskListsArchived(tasklist,i)">
                
                {{tasklist.name}}
              </span>

            </div>


         </div>

          <ng-container
            *ngIf="taskListsArchived.length>0 && i === expandedIndexArchived && taskListsArchived">
            <ng-container *ngFor="let list of taskListsArchived">

              <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
                [ngClass]="{ 'active': taskListIDArchived === list.taskListID }">

                <mat-icon class="type">fiber_manual_record</mat-icon>
                <div class="name_email" (click)="OpenTaskListArchived(list)">

                  <p  matTooltipClass="tooltip" matTooltip="{{list.taskListName}}">
                    {{list.taskListName}}
                  </p>                  

                </div>

                <div class="opt">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vertical</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">

                    <button mat-menu-item (click)="UnarchivedTaskList(list,tasklist,i)">
                      <mat-icon>unarchive</mat-icon>
                      Unarchive
                    </button>

                  </mat-menu>
                </div>

              </div>


            </ng-container>
          </ng-container>


        </div>

      </ng-container>

    </div>
    
  
   </div>
 </div> 



</div>


</mat-card>




<ng-template #addFolderDialog>
 <form [formGroup]="myfolderForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Add {{folderTaskName}}
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  
     <mat-form-field class="">
       <mat-label>{{folderTaskName}} Name</mat-label>
       <input matInput formControlName="folderName" maxlength="100" placeholder="add name"/>
     </mat-form-field>
     <mat-form-field *ngIf="folderortask=='task'">
       <mat-label>Select Template</mat-label>
       <mat-select (selectionChange)="OnSelectTempChange($event)">
         <mat-option *ngFor="let template of TaskTemplatesList" [value]="template.taskTemplateID">
           {{ template.taskTemplateName }}
         </mat-option>
       </mat-select>
      
     </mat-form-field>
 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="close()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="myfolderForm.invalid || !myfolderForm.dirty" 
   (click)="addTaskListFolder(myfolderForm.value)">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>

<ng-template #updateFolderDialog>
 <form [formGroup]="myfolderForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Update {{folderTaskName}}
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  
     <mat-form-field class="">
       <mat-label>{{folderTaskName}} Name</mat-label>
       <input matInput formControlName="folderName" maxlength="100" placeholder="update {{folderTaskName}} Name"/>
     </mat-form-field>
     
 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="close()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="myfolderForm.invalid || !myfolderForm.dirty" 
   (click)="UpdateTaskListFolder(myfolderForm.value)">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>

<ng-template #rename>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Rename Folder
   <button mat-icon-button (click)="close()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <mat-form-field class="example-full-width">
     <mat-label>Rename</mat-label>
     <input matInput placeholder="Rename" value="Heart Surgery" />
   </mat-form-field>
 </mat-dialog-content>
 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="">Close</button>
   <button mat-button color="primary">Save</button>
 </mat-dialog-actions>
</ng-template>



<ng-template #template>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
   Template Gallery
   <button mat-icon-button (click)="closeTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <div class="searchSelectCat">
     <div class="selectCat">
       <mat-form-field appearance="fill">
         <mat-label>Select Category</mat-label>
         <mat-select (selectionChange)="getSelectTaskCategory($event)">
           <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
               {{ stat.taskTemplateCategoryName }}
           </mat-option>
       </mat-select>
        
       </mat-form-field>
     </div> 


     <div class="search">
       <mat-form-field class="example-full-width" appearance="fill">
         <mat-label>Search</mat-label>
         <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
       </mat-form-field>
     </div>  
   </div>

   <div class="tempalteList">
     <table cellspacing="0" cellspadding="0">
       <tr>        
         <th>Template Name</th> 
         <th>Category Name</th>        
         <th class="actBtn" >Action</th>
       </tr>
       <tr>
       
         <td class="formName">
          Template 1
         </td>
         <td>Category 1</td>
         <td>          
   
           <button mat-icon-button color="primary"  mat-icon-button matTooltipClass="tooltip"
            matTooltip="Create Project"><mat-icon>post_add</mat-icon>
           </button>
           
         </td>
       </tr>
     </table>
     
   </div>
 </mat-dialog-content>
 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button  color="" (click)="closeTemplate()">Close</button>   
 </mat-dialog-actions>
</ng-template>


<ng-template #MoveTo>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>note_add</mat-icon></span> 
   Move To
   <button mat-icon-button (click)="closeMoveto()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
      
     <div class="drive mainLink">              
       <div class="folderName" *ngFor="let tasklist of taskListFolderForMoveTo; let i = index">
        
         <div class="" style="display: flex; width: 100%;">

           <div class="nm" (click)="getTaskListsForMoveTo(tasklist,i)">
           
             <mat-icon class="arrow_right"  aria-hidden="true">
               chevron_right 
              </mat-icon>
                      
           <mat-icon class="type">folder</mat-icon>
           {{tasklist.taskListFolderName}}            
         </div>                 
      
         </div>
         
         <ng-container *ngIf="taskListsForMoveTo.length>0 && i === expandedIndexmoveTo">
           <ng-container *ngFor="let list of taskListsForMoveTo">
 
             <div class="subTaskList" style="margin-left:0px;margin-right:0px;"
             (click)="SelectTaskList(list)">  

               <mat-icon class="type">list</mat-icon>
               <p  [ngClass]="{ 'active': taskListIDMoveTo === list.taskListID }"> 
               {{list.taskListName}}      
              </p>

           </div>  
                     
           </ng-container>
         </ng-container>

       </div>
     </div>         
   

 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeMoveto()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="!ButtonForMoveTo" (click)="MoveToTaskList()">
    MoveTo
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>

</ng-template>


<ng-template #saveAsTemplateDialog>
 <form [formGroup]="addTemplateForm"> 
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>create_new_folder</mat-icon></span>
   Save As Template
   <button mat-icon-button (click)="closeSaveAsTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>

 <mat-dialog-content>  

   <mat-form-field appearance="fill">
     <mat-label>Select Category</mat-label>
     <mat-select formControlName="folderID">
       <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
           {{ stat.taskTemplateCategoryName }}
       </mat-option>
   </mat-select>    
   </mat-form-field>

     <mat-form-field class="">
       <mat-label>Template Name</mat-label>
       <input matInput formControlName="taskTemplateName" maxlength="100" placeholder="add template name"/>
     </mat-form-field>

 </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeSaveAsTemplate()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="addTemplateForm.invalid || !addTemplateForm.dirty" 
   (click)="AddTaskTemplate(addTemplateForm.value)">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>
</form>
</ng-template>


<ng-template #Addtemplate>
 <h2 mat-dialog-title>
   <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
   Template Gallery
   <button mat-icon-button (click)="closeTemplate()">
     <mat-icon>close</mat-icon>
   </button>
 </h2>
 <mat-dialog-content>
   <div class="searchSelectCat">
     <div class="selectCat">
       <mat-form-field appearance="fill">
         <mat-label>Select Category</mat-label>
         <mat-select (selectionChange)="getSelectTaskCategory($event)">
           <mat-option value="0">All</mat-option>
           <mat-option *ngFor="let stat of taskCategoryList" [value]="stat.taskTemplateCategoryID">
               {{ stat.taskTemplateCategoryName }}
           </mat-option>
       </mat-select>
        
       </mat-form-field>
     </div> 


     <div class="search">
       <mat-form-field class="example-full-width" appearance="fill">
         <mat-label>Search</mat-label>
         <input matInput maxlength="20" placeholder="search template" (input)="searchTemplate($event.target.value)">
       </mat-form-field>
     </div>  
   </div>

   <div class="tempalteList">
     <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
       <tr>        
         <th>Template Name</th> 
         <th>Category Name</th>        
         <th class="actBtn">Action</th>
       </tr>
       <tr *ngFor="let template of TaskTemplatesList" [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">
       
         <td class="formName">
           {{template.taskTemplateName}}         
         </td>

         <td *ngIf="template.folderName==null">-</td>
         <td *ngIf="template.folderName!=null">{{template.folderName}}</td>

         <td>    
           <button mat-icon-button color="primary" mat-icon-button matTooltipClass="tooltip"
            matTooltip="Select" (click)="SelectTemplate(template)"><mat-icon>post_add</mat-icon>
           </button>            
         </td>
       </tr>
     </table>
     <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
   </div>
 </mat-dialog-content>

 <section class="importTo" *ngIf="taskTemplateID>0">
  <p >Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
  <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
  <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
  <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
</section>

 <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="" (click)="closeTemplate()">Close</button>   

   <button *ngIf="taskTemplateID>0" mat-flat-button class="calltoaction"
     type="submit" color="primary" (click)="ImportTemplate()">
     Import     
  </button>

 </mat-dialog-actions>
</ng-template>


<ng-template #AddTaskListTemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery
    <button mat-icon-button (click)="closeTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 <mat-dialog-content>

   

  <div class="template-holder">
    <div class="left">

      <mat-form-field appearance="fill">
        <mat-label>Select Category</mat-label>
        <mat-select (selectionChange)="onTaskListTabChange($event)" value="My Template" >
          <mat-option value="My Template">My Template</mat-option>
          <mat-option value="Organization">Organization</mat-option>
          <mat-option value="Global">Global</mat-option>
        </mat-select>
      </mat-form-field>

      

      <div class="list" #categoryList>
        <ul>
          <li (click)="getTaskListThroughCategory(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
          <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
            <li (click)="getTaskListThroughCategory(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
          </ng-container>           
        </ul>
      
      </div>

    </div>
   <div class="right"> 
     
     <div class="searrch">
      <mat-form-field class="example-full-width" appearance="fill">
        <mat-label>Search</mat-label>
        <input matInput maxlength="20" placeholder="search template"
          (input)="searchTemplateForTaskList($event.target.value)">
      </mat-form-field>

      <mat-form-field class="">
        <mat-label>Tasklist Name</mat-label>
        <input matInput [(ngModel)]="addtaskTemplateName"  maxlength="100" placeholder="Add Tasklist Name" />
      </mat-form-field>

     </div>



     <div class="list">

      <div class="tempalteList">
        <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
          <tr>
            <th>Template Name</th>             
            <th class="actBtn">Action</th>
          </tr>
          <tr *ngFor="let template of FilteredTaskTemplatesList"
            [ngClass]="{ 'active': template.taskTemplateID === taslTemplateID}">

            <td class="formName">
              {{template.taskTemplateName}}
            </td>            

            <td>
              <span class="import" (click)="templateSelected(template)" >Select</span>
            </td>
          </tr>
        </table>
        <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
      </div>

     </div>
        
   </div>
</div>    
 </mat-dialog-content>

 <section class="importTo">
  <p>Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
  <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
  <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
  <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
</section>


 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   <button mat-button color="basic" (click)="closeTemplate()">Cancel</button>
   <button mat-flat-button class="calltoaction" type="submit" color="primary"
   [disabled]="!showAddTemp"
   (click)="SelectTemplateForTaskList()">
    Add
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
 </mat-dialog-actions>

</ng-template>




<ng-template #importTasktemplate>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Template Gallery

    <!-- <button mat-stroked-button color="primary" class="import" *ngIf="selectedTemplate.length>0" (click)="importTaskTemplates()">Import</button> -->

    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
 

    <div class="template-holder">
      <div class="left">

        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="onTaskListTabChangeForTaskImport($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>           
          </mat-select>
        </mat-form-field>

        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForTaskImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }" >All</li>
            <ng-container  *ngFor="let stat of filteredTaskCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForTaskImport(stat.taskTemplateCategoryID, i+1)" [ngClass]="{'active': currentIndex == i+1 }"  > {{ stat.taskTemplateCategoryName }}</li>
            </ng-container>           
          </ul>
        
        </div>

      </div>
     <div class="right"> 
       
      

       <div class="searrch">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Search</mat-label>
          <input matInput maxlength="20" placeholder="Search Template"
            (input)="searchTemplateForSingleTask($event.target.value)">
        </mat-form-field>
       </div>
  
       

        <div class="tempalteList">
          <table cellspacing="0" cellspadding="0" *ngIf="!ShowNoRecordFoundTaskTemplates">
            <tr>
              <th> </th>
              <th>Template Name</th>             
              <th class="">&nbsp;</th>
            </tr>
            <tr *ngFor="let template of  TaskTemplatesListForSingleTask"
             [ngClass]="{ 'active': template.taskId === taskTemplateIDForSingleTask}">

             <td>
              <mat-checkbox color="primary" (change)="getCheckboxValues($event, template)">
              </mat-checkbox>
            </td> 

              <td class="formName">
                {{template.templateName}}
              </td>            

              <td>
                &nbsp;
              </td>
            </tr>
          </table>
          <div *ngIf="ShowNoRecordFoundTaskTemplates" class="noRecordFound">No Record Found</div>
        </div>

     
  
     </div>
  </div>  

  <section class="importTo" *ngIf="selectedTemplate.length>0">
    <p >Would you like to import data for the newly created task-list? If so, please select the appropriate options below. If not, simply uncheck any boxes you do not wish to pull data from.</p>
    <!-- <mat-checkbox color="primary" [(ngModel)]="AttachChecked" (change)="showOptions($event,'Attach')">Attach</mat-checkbox> &nbsp; -->
    <mat-checkbox color="primary" [(ngModel)]="AssigneeChecked" (change)="showOptions($event,'Assignee')">Assignee</mat-checkbox>&nbsp;
    <!-- <mat-checkbox color="primary" [(ngModel)]="NotifyChecked" (change)="showOptions($event,'Notify')">Notify</mat-checkbox> -->
  </section>

  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>     

    <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="selectedTemplate.length>0"
      (click)="importTaskTemplates()">
      Import     
    </button>
  </mat-dialog-actions> 


</ng-template>
